import React, { type ReactElement, useMemo } from 'react'
import { Typography, useTheme } from '@mui/material'
import SimpleTooltip from 'common/ui/simple-tooltip'
import { Role } from 'common/utils/types'
import {
  getCertificateIcon,
  getValidityCertificateDate,
  useIsDatePassed,
} from 'common/certificates/certificates.functions'
import { useAppSelector } from 'store/hooks'
import { formatDate } from 'utils/functions'
import { ReactComponent as CompanyIcon } from 'assets/companyIcon.svg'

import VendorInfoPanel from '../vendor-info-panel'

import styles from './Certificates.module.scss'

const Certificates: React.FC = (): ReactElement => {
  const theme = useTheme()
  const { palette } = useTheme()
  const { userInfo } = useAppSelector((state) => state.auth)
  const { vendor } = useAppSelector((state) => state.vendor)

  const earliestValidTo = useMemo(() => {
    if (!vendor?.user?.certificates) {
      return null
    }
    return getValidityCertificateDate(vendor.user)
  }, [vendor?.user?.certificates])

  const isDatePassed = useIsDatePassed(earliestValidTo)

  return (
    <VendorInfoPanel
      title="Sertifikati"
      icon={<CompanyIcon fill={theme.palette.green.main} />}
      className={styles.certificatesContainer}
      contentClassName={styles.documents}
      empty={userInfo?.role === Role.admin ? !!vendor?.user?.certificates.length : undefined}
      onClick={() => {
        window.location.href = `${window.location.origin}/korisnici/certificates`
      }}
    >
      <div className={styles.certificates}>
        {[...Array(5)].map((_, index) => (
          <div key={index} className={styles.certificate}>
            {vendor?.user?.certificates && index < vendor?.user?.certificates?.length ? (
              <SimpleTooltip
                title={vendor?.user?.certificates[index]?.name || 'Nema sertifikata'}
                style={{ textAlign: 'left', height: 35, width: 40 }}
              >
                {getCertificateIcon(vendor?.user?.certificates[index]?.slug, 35, 40)}
              </SimpleTooltip>
            ) : (
              <></>
            )}
          </div>
        ))}
      </div>
      <div className={styles.dates}>
        <div className={styles.dateContainer}>
          <Typography variant="title4">Datum važenja</Typography>
          <div className={styles.dateLabel}>
            <Typography
              variant="title3"
              style={{ color: isDatePassed ? palette.charts.red.main : palette.green.main }}
            >
              {earliestValidTo ? formatDate(earliestValidTo) : '-'}
            </Typography>
          </div>
        </div>
      </div>
    </VendorInfoPanel>
  )
}

export default Certificates
